<template>
  <div class="nixom">
    <!-- Toggle Navbar Items -->

    <div>
      <b-navbar toggleable="lg" type="dark" variant="primary" fixed="top">
        <b-container>
          <b-navbar-brand href="/">
            <i class="material-icons md-12 toy">toys</i>
            <span class="name">dammyton</span>
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <b-navbar-nav>
                <b-nav-item href="#services">SERVICES</b-nav-item>
                <b-nav-item href="#portfolio">PORTFOLIO</b-nav-item>
                <b-nav-item href="#pricing">PRICING</b-nav-item>
                <b-nav-item href="#contact">CONTACT</b-nav-item>
              </b-navbar-nav>
            </b-navbar-nav>
          </b-collapse>
        </b-container>
      </b-navbar>
    </div>

    <div class="well">
      <b-container-fluid>
        <b-row style="margin-left:0px;margin-right: 0; !important;">
          <b-col sm="3" md="3"></b-col>

          <b-col sm="6" md="6" style="padding:12% 0px;">
            <div class="spec">
              <div class="text-center">
                <span style="font-family:'Noto sans',serif;font-size:50px ">Hi,</span>
                <h4 style="font-family:'Noto sans'">I'm DAMILOLA OWOLABI</h4>
              </div>
              <div>
                <center>
                  <b-card style="width:75%">
                    <b-container>
                      <b-row class="main-box">
                        <b-col md="4" class="box" sm="4">
                          <img
                            src="../assets/img.jpg"
                            alt="user"
                            width="150px"
                            height="150px"
                            class="rounded-circle"
                            align="center"
                          />
                        </b-col>
                        <b-col md="8" sm="8" class="box2">
                          <p
                            class="mt-3"
                            style="color:#007bff;margin-bottom: 0.01rem;"
                          >Software Developer</p>

                          <div id="flip">
                            <div>
                              <div>JavaScript Geek</div>
                            </div>
                            <div>
                              <div>Wordpress Developer</div>
                            </div>
                            <div>
                              <div>Tech-Savvy</div>
                            </div>
                          </div>

                          <i style="color:#007bff; font-size:10px" class="fa fa-map-marker"></i>
                          <span
                            style="color:#3e5569;
                        font-size:12px;
                        font-family:'Noto sans',sans-seriff"
                          >Lagos, Nigeria.</span>
                          <br />
                          <p style="margin-top: 1rem;margin-bottom:0">
                            <a class="btn btn-primary btn-sm get" href="#portfolio">Get Started</a>
                          </p>
                        </b-col>
                      </b-row>
                    </b-container>
                  </b-card>
                </center>
              </div>
            </div>
          </b-col>
          <b-col class="welcome" sm="3" md="3"></b-col>
        </b-row>
      </b-container-fluid>
    </div>

    <div id="services">
      <b-container>
        <b-row>
          <b-col md="4" sm="12">
            <center>
              <i class="material-icons services_ic">important_devices</i>
              <h6 class="services_hd">DESIGN + DEVELOPMENT</h6>
              <p
                class="services_cont"
              >Clean, User-friendly & Responsive web pages that automatically adjust to display correctly on any size screen.</p>
            </center>
          </b-col>
          <b-col md="4" sm="12">
            <center>
              <i class="material-icons services_ic">assessment</i>
              <h6 class="services_hd">ANALYTICS</h6>
              <p
                class="services_cont"
              >Identify what users are doing on your business or blog website. So, you take productive decisions that grow your profit and increase website traffic</p>
            </center>
          </b-col>
          <b-col md="4" sm="12">
            <center>
              <i class="material-icons services_ic">youtube_searched_for</i>
              <h6 class="services_hd">SEO Optimization</h6>
              <p
                class="services_cont"
              >The website ranks high in the search engines for relevant keywords and phrases, This helps you reach and engage more potential customers</p>
            </center>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <hr />

    <div id="portfolio" class="active">
      <b-container>
        <h6 class="text-center mt-3 pb-4" style="font-size:20px">PORTFOLIO</h6>

         <b-row class="ptf">
          <b-col md="6" sm="12">
            <div align="center">
              <img src="../assets/1.png" style="width:300px;height:auto" />
            </div>
          </b-col>
          <b-col md="6" sm="12">
            <p class="pl-5 pr-5 mt-4">
              <i class="material-icons ic" style="color:#007bff;font-size:13px">check_circle</i>
              <b style="font-family: open sans,sans-serif;">Best Tour Plan</b>
            </p>
            <p style="font-size:13px;color:#88878d" class="pl-5 pr-5">
              An Hotel website template
              <br />
              <span>
                <a class="mt-3 visit" href="https://best-tour-plan.netlify.app/">Visit Site</a>
              </span>
            </p>
          </b-col>
        </b-row>
        <hr />


        <b-row class="ptf2">
          <b-col md="6" sm="12">
            <div align="center">
              <img src="../assets/10.png" style="width:300px;height:auto" />
            </div>
          </b-col>
          <b-col md="6" sm="12">
            <p class="pl-5 pr-5 mt-4">
              <i class="material-icons ic" style="color:#007bff;font-size:13px">check_circle</i>
              <b style="font-family: open sans,sans-serif;">Planite</b>
            </p>
            <p style="font-size:13px;color:#88878d" class="pl-5 pr-5">
              A wedding planner portfolio, check it out you'll definitely love it
              <br />
              <span>
                <a class="mt-3 visit" href="https://dammyton-wedding-planner.netlify.app/">Visit Site</a>
              </span>
            </p>
          </b-col>
        </b-row>
        <hr />

        <b-row class="ptf">
          <b-col md="6" sm="12">
            <div align="center">
              <img src="../assets/11.png" style="width:300px;height:auto" />
            </div>
          </b-col>
          <b-col md="6" sm="12">
            <p class="pl-5 pr-5 mt-4">
              <i class="material-icons ic" style="color:#007bff;font-size:13px">check_circle</i>
              <b style="font-family: open sans,sans-serif;">Mini-Portfolio</b>
            </p>
            <p style="font-size:13px;color:#88878d" class="pl-5 pr-5">
             A mini portfolio for any profession
              <br />
              <span>
                <a class="mt-3 visit" href="https://dammyton-devc.netlify.app/">Visit Site</a>
              </span>
            </p>
          </b-col>
        </b-row>
        <hr />

        <b-row class="ptf2">
          <b-col md="6" sm="12">
            <div align="center">
              <img src="../assets/6.png" style="width:300px;height:auto" />
            </div>
          </b-col>
          <b-col md="6" sm="12">
            <p class="pl-5 pr-5 mt-4">
              <i class="material-icons ic" style="color:#007bff;font-size:13px">check_circle</i>
              <b style="font-family: open sans,sans-serif;">COVID-19Stats</b>
            </p>
            <p style="font-size:13px;color:#88878d" class="pl-5 pr-5">
              A Monitoring Dashboard for corona virus
              <br />
              <span>
                <a class="mt-3 visit" href="https://covid19-statistics-1.netlify.app/">Visit Site</a>
              </span>
            </p>
          </b-col>
        </b-row>
        <hr />

        <b-row class="ptf">
          <b-col md="6" sm="12">
            <div align="center">
              <img src="../assets/2.png" style="width:300px;height:auto" />
            </div>
          </b-col>
          <b-col md="6" sm="12">
            <p class="pl-5 pr-5 mt-4">
              <i class="material-icons ic" style="color:#007bff;font-size:13px">check_circle</i>
              <b style="font-family: open sans,sans-serif;">RCF TASUED WEBSITE</b>
            </p>
            <p style="font-size:13px;color:#88878d" class="pl-5 pr-5">
              Church Management System,a promising and potentially transforming E-environment.
              <br />
              <span>
                <a class="mt-3 visit" href="https:/rcftasued.com/">Visit Site</a>
              </span>
            </p>
          </b-col>
        </b-row>
        <hr />

        <b-row class="ptf2">
          <b-col md="6" sm="12">
            <div align="center">
              <img src="../assets/3.png" style="width:300px;height:auto" />
            </div>
          </b-col>
          <b-col md="6" sm="12">
            <p class="pl-5 pr-5 mt-3">
              <i class="material-icons ic" style="color:#007bff;font-size:13px">check_circle</i>
              <b style="font-family: open sans,sans-serif;">PLATINIUMNETS</b>
            </p>
            <p style="font-size:13px;color:#88878d" class="pl-5 pr-5">
              A website that specializes in digital skills,web development and design,Graphics Design,search engine optimization and all web related activities to Idea Validation and incubation.
              <br />
              <span>
                <a class="mt-3 visit" href="https://platiniumnets.com/">Visit Site</a>
              </span>
            </p>
          </b-col>
        </b-row>
        <hr />



        <b-row class="ptf">
          <b-col md="6" sm="12">
            <div align="center">
              <img src="../assets/5.png" style="width:300px;height:auto" />
            </div>
          </b-col>
          <b-col md="6" sm="12">
            <p class="pl-5 pr-5 mt-4">
              <i class="material-icons ic" style="color:#007bff;font-size:13px">check_circle</i>
              <b style="font-family: open sans,sans-serif;">SSL (Show-Some-Love)</b>
            </p>
            <p style="font-size:13px;color:#88878d" class="pl-5 pr-5">
              A Customized Birthday Web App
              <br />
              <span>
                <a class="mt-3 visit" href="https://show-some-love.netlify.app">Visit Site</a>
              </span>
            </p>
          </b-col>
        </b-row>
        <hr />


        <b-row class="ptf2">
          <b-col md="6" sm="12">
            <div align="center">
              <img src="../assets/7.png" style="width:300px;height:auto" />
            </div>
          </b-col>
          <b-col md="6" sm="12">
            <p class="pl-5 pr-5 mt-4">
              <i class="material-icons ic" style="color:#007bff;font-size:13px">check_circle</i>
              <b style="font-family: open sans,sans-serif;">Manage</b>
            </p>
            <p style="font-size:13px;color:#88878d" class="pl-5 pr-5">
              Manage makes it simple for software teams
              to plan day-to-day tasks while keeping the
              larger team goals in view.
              <br />
              <span>
                <a class="mt-3 visit" href="https://manage-landing-temp.netlify.app/">Visit Site</a>
              </span>
            </p>
          </b-col>
        </b-row>
        <hr />

        <b-row class="ptf">
          <b-col md="6" sm="12">
            <div align="center">
              <img src="../assets/8.png" style="width:300px;height:auto" />
            </div>
          </b-col>
          <b-col md="6" sm="12">
            <p class="pl-5 pr-5 mt-4">
              <i class="material-icons ic" style="color:#007bff;font-size:13px">check_circle</i>
              <b style="font-family: open sans,sans-serif;">Fusion</b>
            </p>
            <p style="font-size:13px;color:#88878d" class="pl-5 pr-5">
              A business landing page template
              <br />
              <span>
                <a class="mt-3 visit" href="https://fusion-landing-template.netlify.app/">Visit Site</a>
              </span>
            </p>
          </b-col>
        </b-row>
        <hr />

        <b-row class="ptf2">
          <b-col md="6" sm="12">
            <div align="center">
              <img src="../assets/9.png" style="width:300px;height:auto" />
            </div>
          </b-col>
          <b-col md="6" sm="12">
            <p class="pl-5 pr-5 mt-4">
              <i class="material-icons ic" style="color:#007bff;font-size:13px">check_circle</i>
              <b style="font-family: open sans,sans-serif;">RHODA</b>
            </p>
            <p style="font-size:13px;color:#88878d" class="pl-5 pr-5">
              A Chatbot
              <br />
              <span>
                <a class="mt-3 visit" href="https://dammyton-chatbot.netlify.app/">Visit Site</a>
              </span>
            </p>
          </b-col>
        </b-row>
        <hr />

        <b-row class="ptf">
          <b-col md="6" sm="12">
            <div align="center">
              <img src="../assets/4.png" style="width:300px;height:auto" />
            </div>
          </b-col>
          <b-col md="6" sm="12">
            <p class="pl-5 pr-5 mt-2">
              <i class="material-icons ic" style="color:#007bff;font-size:13px">check_circle</i>
              <b style="font-family: open sans,sans-serif;">LIdapearl Hotel</b>
            </p>
            <p style="font-size:13px;color:#88878d" class="pl-5 pr-5">
              Lidapearl Hotels operates a first class hotel
              for business and leisure travelers. It is perceived as a first class, full service,
              efficient, friendly, modern and informal
              innovative service concepts.
              <br />
              <span>
                <a class="mt-3 visit" href="https://lidapearl-hotel.netlify.app/">Visit Site</a>
              </span>
            </p>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <div id="pricing">
      <b-container>
        <h6 class="text-center mt-3 pb-4" style="font-size:20px;color: #fff;">PRICING</h6>
        <b-row>
          <b-col md="4" sm="12">
            <center>
              <b-card-group deck style="width:90%">
                <b-card align="center" class="dsh">
                  <p style="color:#01b5ff;font-weight:bold">BASIC</p>
                  <b-card-text>Design</b-card-text>
                  <b-card-text>Development</b-card-text>
                  <b-card-text>Hosting</b-card-text>
                  <b-card-text>Analytics</b-card-text>
                  <span>
                    <a class="mt-3 quote" href="#contact">Request Quote</a>
                  </span>
                </b-card>
              </b-card-group>
            </center>
          </b-col>
          <b-col md="4" sm="12">
            <center>
              <b-card-group deck style="width:90%">
                <b-card align="center" class="dshh">
                  <p style="color:orange;font-weight:bold">STANDARD</p>
                  <b-card-text>Design</b-card-text>
                  <b-card-text>Development</b-card-text>
                  <b-card-text>Hosting</b-card-text>
                  <b-card-text>Analytics</b-card-text>
                  <b-card-text>Email Setup</b-card-text>
                  <b-card-text>Search Engine Optimization</b-card-text>
                  <span>
                    <a class="mt-3 quote2" href="#contact">Request Quote</a>
                  </span>
                </b-card>
              </b-card-group>
            </center>
          </b-col>
          <b-col md="4" sm="12">
            <center>
              <b-card-group deck style="width:90%">
                <b-card align="center" class="dshhh">
                  <p style="color:darkcyan;font-weight:bold">PREMIUM</p>
                  <b-card-text>Design</b-card-text>
                  <b-card-text>Development</b-card-text>
                  <b-card-text>Hosting</b-card-text>
                  <b-card-text>Analytics</b-card-text>
                  <b-card-text>Email Setup</b-card-text>
                  <b-card-text>Search Engine Optimization</b-card-text>
                  <b-card-text>Backups</b-card-text>
                  <b-card-text>Live Chat</b-card-text>
                  <b-card-text>Content Management</b-card-text>
                  <b-card-text>Maintenance Agreement</b-card-text>
                  <span>
                    <a class="mt-3 quote3" href="#contact">Request Quote</a>
                  </span>
                </b-card>
              </b-card-group>
            </center>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <transition name="fade">
      <div id="contact">
        <b-container>
          <h6 class="text-center mt-3 pb-5">Get in touch</h6>
          <b-row>
            <b-col md="2"></b-col>
            <b-col md="8">
              <b-form
                action="https://send.pageclip.co/NJxYtjMteAraV4XeddXNiESkuQBXhxA0"
                class="pageclip-form"
                method="post"
              >
                <b-form-group label="Email">
                  <b-form-input
                    id="input-1"
                    v-model="form.email"
                    name="Email"
                    type="email"
                    required
                  ></b-form-input>
                </b-form-group>

                <b-form-group label="Message">
                  <textarea
                    v-model="form.message"
                    rows="7"
                    name="Message"
                    required
                    class="form-control"
                  ></textarea>
                </b-form-group>

                <center>
                  <span>
                    <input class="mt-1 send" type="submit" value="send" />
                  </span>
                </center>
              </b-form>
              <div class="mt-5 text-center">
                <p class="section">
                  <a href="mailto:owolabidamilola98@gmail.com" class="link m-3 mb-0">
                    <i class="fa fa-envelope" style="color:#007bff;font-size:20px"></i>
                  </a>

                  <a
                    href="https://www.linkedin.com/in/damilola-owolabi-7821b714a"
                    class="link m-3 mb-0"
                  >
                    <i class="fa fa-linkedin" style="color:#007bff;font-size:20px"></i>
                  </a>

                  <a href="https://mobile.twitter.com/Dammyton16" class="link m-3 mb-0">
                    <i class="fa fa-twitter" style="color:#007bff;font-size:20px"></i>
                  </a>
                </p>
              </div>
            </b-col>
            <b-col md="2"></b-col>
          </b-row>
        </b-container>
      </div>
    </transition>
  </div>
</template>


<script>
import axios from "axios";

export default {
  data() {
    return {
      form: {
        email: "",
        message: ""
      },
      show: true
    };
  }
};
</script>
<style scoped>

#flip {
  height: 18px;
  overflow: hidden;
}

#flip > div > div {
  color: #3e5569;
  font-size: 12px;
  font-family: "Noto sans", sans-seriff;
  display: inline-block;
}

#flip div:first-child {
  animation: show 15s linear infinite;
}
@keyframes show {
  66% {
    margin-top: -70px;
  }
}

@keyframes Slide_right {
  0% {
    transform: translateX(-400px);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes Slide_left {
  0% {
    transform: translateX(400px);
  }
  100% {
    transform: translateX(0);
  }
}
.ptf {
  animation: Slide_left 1.1s ease-in;
}
.ptf2 {
  animation: Slide_right 1.1s ease-in;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes bounceIn {
  0% {
    transform: scale(0.1);
    opacity: 0;
  }
  60% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(1);
  }
}
.spec {
  animation: bounceIn 2s ease-in;
}
.phaybg {
  background: #01b5ff;
}
.get {
  color: #ffffff;
}
.get:hover {
  color: #007bff;
  background: #ffffff;
  border: 1px solid #007bff;
}
.nixom {
  padding-top: 60px;
}
.name {
  font-size: 10px;
  font-family: serif;
}
.toy {
  animation-name: spin;
  animation-duration: 5000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
.nav-item,
.nav-link {
  font-size: 12px;
  color: #ffffff !important;
}
.nav-link:hover {
  color: rgba(255, 255, 255, 0.5) !important;
}

.nav-link:active,
.nav-link:focus {
  color: #9c27b0 !important;
}

a.active {
  color: orange;
}
legend {
  color: #c8c5cb !important;
}
.well {
  background: linear-gradient(
    to top,
    #007bff,
    #00d0ff,
    #00d0ff,
    #007bff,
    #007bff
  );
  /* background: url('../assets/bl.png'); */
  width: auto;
  height: 650px;
  background-position: left;
  background-size: cover;
  color: #fff;
  background-attachment: fixed;
}
#services {
  padding-top: 120px;
  padding-bottom: 80px;
}
#portfolio {
  padding-top: 80px;
  padding-bottom: 80px;
}
#pricing {
  padding-top: 80px;
  padding-bottom: 50px;
  background: #007bff;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
}
#contact {
  padding-top: 50px;
}
a {
  color: #007bff;
  text-decoration: none;
}
.col-md-3,
.col-sm-6 {
  width: auto;
}
.services_hd {
  color: #01b5ff;
  font-size: 15px;
  padding: 7px;
}
.services_ic {
  color: #01b5ff;
  font-size: 40px;
}
.services_cont {
  font-size: 13px;
}
i {
  font-size: 28px;
}
p.card-text {
  margin-bottom: 0px;
}
.material-icons.md-36 {
  font-size: 36px;
}
.material-icons.md-12 {
  font-size: 12px;
  color: #ffffff;
}

.des {
  font-size: 18px;
}

.dsh {
  border-radius: 0px 30px 0px 30px;
  width: 90%;
  height: 230px;
}
.dshh {
  border-radius: 0px 30px 0px 30px;
  width: 90%;
  /* height: 280px; */
}
.dshhh {
  border-radius: 0px 30px 0px 30px;
  width: 90%;
  /* height: 375px; */
}
.dsh2 {
  border-radius: 0px 30px 0px 30px;
  padding: auto;
  height: 40px;
  width: 120px;
  background-color: #01b5ff;
  color: white;
}
.dsh2 > div.card-body {
  padding: 10px 0;
}
.dsh3 {
  border-radius: 50%;
  height: 80px;
  width: 80px !important;
}
.dsh4 {
  border-radius: 0px 40px 0px 40px;
  width: 100%;
  height: 70px;
}
.myuser {
  font-size: 40px;
}
.name {
  font-size: 24px;
}
.fa-connectdevelop {
  font-size: 18px;
  font-weight: 900;
}
.send {
  color: #fff;
  background: #007bff;
  padding: 5px 20px;
  border-radius: 20px;
  border-color: #007bff;
  display: inline-block;
  user-select: none;
  font-size: 1rem;
  font-weight: 700;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
}
.send:hover {
  background: #ffffff;
  color: #007bff;
  border: 1px solid #007bff;
}
.quote {
  color: #fff;
  background: #01b5ff;
  padding: 5px 20px;
  border-radius: 20px;
  border-color: #01b5ff;
  display: inline-block;
  user-select: none;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
}
.quote:hover {
  background: #ffffff;
  color: #01b5ff;
  border: 1px solid #01b5ff;
}
.quote2 {
  color: #fff;
  background: orange;
  padding: 5px 20px;
  border-radius: 20px;
  border-color: orange;
  display: inline-block;
  user-select: none;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
}
.quote2:hover {
  background: #ffffff;
  color: orange;
  border: 1px solid orange;
}
.quote3 {
  color: #fff;
  background: darkcyan;
  padding: 5px 20px;
  border-radius: 20px;
  border-color: darkcyan;
  display: inline-block;
  user-select: none;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
}
.quote3:hover {
  background: #ffffff;
  color: darkcyan;
  border: 1px solid darkcyan;
}
.visit {
  color: #fff;
  background: #007bff;
  padding: 5px 17px;
  border-radius: 20px;
  border-color: #007bff;
  display: inline-block;
  user-select: none;
  font-size: 9px;
  font-weight: 500;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
}
.visit:hover {
  background: #ffffff;
  color: #007bff;
  border: 1px solid #007bff;
}
h6 {
  font-weight: 900;
  font-size: 25px;
}

@media (width: 768px) {
  .box {
    max-width: 100%;
  }
  .box2 {
    width: 100%;
    margin-left: 30px;
  }
  .main-box {
    width: 95%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue